'use client';

import * as React from 'react';
import { usePathname } from 'next/navigation';
import NiceModal from '@ebay/nice-modal-react';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

import { AnalyticsProvider } from '@workspace/analytics/hooks/use-analytics';
import { MonitoringProvider } from '@workspace/monitoring/hooks/use-monitoring';
import { TooltipProvider } from '@workspace/ui/components/tooltip';
import { ThemeProvider } from '@workspace/ui/hooks/use-theme';

export function Providers({
  children
}: React.PropsWithChildren): React.JSX.Element {
  // The customer-facing portals are always dark and are not the operator's to
  // theme. Forcing it here lets next-themes own `<html>` uncontested -- without
  // this it would rewrite the class back to the operator's preference after
  // hydration, which is what the old DarkScope observer existed to undo.
  const pathname = usePathname();
  const isPortalRoute =
    pathname.startsWith('/warranty') || pathname.startsWith('/portalx');

  return (
    <MonitoringProvider>
      <AnalyticsProvider>
        <NuqsAdapter>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            forcedTheme={isPortalRoute ? 'dark' : undefined}
            disableTransitionOnChange
          >
            <TooltipProvider>
              <NiceModal.Provider>{children}</NiceModal.Provider>
            </TooltipProvider>
          </ThemeProvider>
        </NuqsAdapter>
      </AnalyticsProvider>
    </MonitoringProvider>
  );
}
